import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown32Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconThumbsDown32Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M23.938 19a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4h-1v14zm-3 1.136V5H10.576a4 4 0 0 0-3.677 2.424l-2.571 6C3.196 16.064 5.132 19 8.004 19h4.434l-.733 6.106c-.234 1.95 2.19 3.034 3.488 1.56z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown32Filled);
